"use strict";

var _interopRequireDefault = require("/home/sitc1119/.jenkins/workspace/sitceb-booking-ui-prod/node_modules/@babel/runtime/helpers/interopRequireDefault.js");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
require("core-js/modules/es7.array.includes");
var _regeneratorRuntime2 = _interopRequireDefault(require("/home/sitc1119/.jenkins/workspace/sitceb-booking-ui-prod/node_modules/@babel/runtime-corejs2/helpers/regeneratorRuntime.js"));
require("regenerator-runtime/runtime");
var _asyncToGenerator2 = _interopRequireDefault(require("/home/sitc1119/.jenkins/workspace/sitceb-booking-ui-prod/node_modules/@babel/runtime-corejs2/helpers/asyncToGenerator.js"));
require("core-js/modules/es6.function.name");
var _objectSpread2 = _interopRequireDefault(require("/home/sitc1119/.jenkins/workspace/sitceb-booking-ui-prod/node_modules/@babel/runtime-corejs2/helpers/objectSpread2.js"));
require("core-js/modules/es6.number.constructor");
var _vuex = require("vuex");
var _DragDialog = _interopRequireDefault(require("@/components/DragDialog"));
var _blExchangeAppointment = require("@/api/blExchangeAppointment/blExchangeAppointment");
var _booking = require("@/api/bookSpace/booking");
var _utils = require("@/utils");
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
var _default2 = exports.default = {
  name: 'BatchReservationComm',
  components: {
    dragDialog: _DragDialog.default
  },
  props: {
    edoCreditId: {
      type: String,
      default: ''
    },
    vvLBlNo: {
      type: String,
      default: ''
    },
    portCode: {
      type: String,
      default: ''
    },
    forespeakBlNo: {
      type: Array,
      default: function _default() {
        return [];
      }
    },
    paymentStatus: {
      type: Number,
      default: 0
    },
    forespeakStatus: {
      type: Number,
      default: 0
    },
    paymentStatusList: {
      type: Array,
      default: function _default() {
        return [];
      }
    },
    forespeakStatusList: {
      type: Array,
      default: function _default() {
        return [];
      }
    },
    edoPaymentMethod: {
      type: Array,
      default: function _default() {
        return [];
      }
    }
  },
  data: function data() {
    var _this = this;
    return {
      invoiceHistory: JSON.parse(localStorage.getItem('invoiceHistory')) || [],
      emailHistory: JSON.parse(localStorage.getItem('emailHistory')) || [],
      acceptList: '.pdf, .jpg, .png, .bmp, .tiff',
      fileList: [],
      portMediaCodeList: [],
      form: {
        blNo: '',
        forespeakBlNo: [],
        paymentStatus: 0,
        forespeakStatus: 0,
        doType: 0,
        invoiceTitle: '',
        paymentMethod: 1,
        attachment: '',
        // 水单附件
        attachmentName: '',
        portMediaCode: '',
        mail: '',
        identifier: '',
        consigneeName: '',
        consigneeAddress: '',
        address: '',
        phone: '',
        accountBank: '',
        invoiceTaxNo: '',
        invoiceBankNo: '',
        edoCreditId: '',
        bankSlip: [],
        del: this.portCode
      },
      loading: null,
      rules: {
        invoiceTitle: [{
          required: true,
          message: this.$t('blExchangeAppointment.invoiceTitleNotNull'),
          trigger: 'blur'
        }],
        paymentMethod: [{
          required: true,
          message: this.$t('blExchangeAppointment.paymentMethodNotNull'),
          trigger: 'blur'
        }],
        attachment: [{
          required: true,
          validator: this.validateAttachment,
          trigger: 'blur'
        }],
        portMediaCode: [{
          required: true,
          validator: this.validatePortMediaCode,
          trigger: 'blur'
        }],
        mail: [{
          required: true,
          message: this.$t('blExchangeAppointment.emailNotNull'),
          trigger: 'blur'
        }, {
          type: 'email',
          message: this.$t('blExchangeAppointment.invalidEmail'),
          trigger: 'blur'
        }, {
          pattern: /^[\w-]+(\.[\w-]+)*@[\w-]+(\.[\w-]+)+$/,
          message: this.$t('blExchangeAppointment.invalidEmail'),
          trigger: 'blur'
        }],
        phone: [{
          validator: function validator(rule, value, callback) {
            if (!value) {
              callback();
            } else {
              var mobile = /^1[3456789]\d{9}$/;
              var tel = /^(\(\d{3,4}\)|\d{3,4}-|\s)?\d{7,14}$/;
              if (mobile.test(value) || tel.test(value)) {
                callback();
              } else {
                callback(new Error(_this.$t('blExchangeAppointment.invalidPhone')));
              }
            }
          },
          trigger: 'blur'
        }],
        invoiceBankNo: [{
          validator: function validator(rule, value, callback) {
            if (!value) {
              callback();
            } else {
              var reg = /^[0-9]*$/;
              if (!reg.test(value)) {
                callback(new Error(_this.$t('blExchangeAppointment.inputNum')));
              } else {
                callback();
              }
            }
          },
          trigger: 'blur'
        }]
      }
    };
  },
  computed: (0, _objectSpread2.default)({}, (0, _vuex.mapGetters)(['language'])),
  methods: {
    querySearchInvoice: function querySearchInvoice(queryString, cb) {
      var _this2 = this;
      this.restaurants1 = [];
      this.invoiceHistory.map(function (item) {
        _this2.restaurants1.push({
          value: item.invoiceTitle
        });
      });
      cb(this.restaurants1);
    },
    querySearchMail: function querySearchMail(queryString, cb) {
      var _this3 = this;
      this.restaurants2 = [];
      this.emailHistory.map(function (item) {
        _this3.restaurants2.push({
          value: item.mail
        });
      });
      cb(this.restaurants2);
    },
    addInvoiceHistory: function addInvoiceHistory() {
      var _this4 = this;
      if (this.form.invoiceTitle) {
        var obj = {
          invoiceTitle: this.form.invoiceTitle
        };
        if (this.invoiceHistory.some(function (item) {
          return item.invoiceTitle === _this4.form.invoiceTitle;
        })) {} else {
          this.invoiceHistory.unshift(obj);
        }
        while (this.invoiceHistory.length > 5) {
          this.invoiceHistory.pop();
        }
        localStorage.setItem('invoiceEmailHistory', JSON.stringify(this.invoiceHistory));
      }
    },
    addEmailHistory: function addEmailHistory() {
      var _this5 = this;
      if (this.form.mail) {
        var obj = {
          mail: this.form.mail
        };
        if (this.emailHistory.some(function (item) {
          return item.mail === _this5.form.mail;
        })) {} else {
          this.emailHistory.unshift(obj);
        }
        while (this.emailHistory.length > 5) {
          this.emailHistory.pop();
        }
        localStorage.setItem('invoiceEmailHistory', JSON.stringify(this.emailHistory));
      }
    },
    addHistoryInfo: function addHistoryInfo() {
      this.addInvoiceHistory();
      this.addEmailHistory();
    },
    beforeRemove: function beforeRemove(file) {
      return this.$confirm("\u786E\u5B9A\u79FB\u9664 ".concat(file.name, "\uFF1F"));
    },
    validateAttachment: function validateAttachment(rule, value, callback) {
      if (this.form.attachment == '' || this.form.attachment == null) {
        callback(new Error(this.$t('blExchangeAppointment.bankSlipNotNull')));
      } else {
        callback();
      }
    },
    validatePortMediaCode: function validatePortMediaCode(rule, value, callback) {
      if (this.form.portMediaCode == '' || this.form.portMediaCode == null) {
        callback(new Error(this.$t('blExchangeAppointment.portMediaCodeNotNull')));
      } else {
        callback();
      }
    },
    handleCancel: function handleCancel() {
      var _this6 = this;
      this.loading = (0, _utils.load)();
      (0, _blExchangeAppointment.cancelForespeak)(this.form.edoCreditId).then(function (res) {
        if (res.success) {
          _this6.form = (0, _objectSpread2.default)((0, _objectSpread2.default)({}, _this6.form), res.data);
          _this6.$message({
            message: _this6.$t('blExchangeAppointment.cancelReservationSuccess'),
            type: 'success'
          });
          _this6.closed();
        } else {
          _this6.$message.error(_this6.$t('blExchangeAppointment.cancelReservationFail'));
        }
        _this6.closed();
      }).catch(function (err) {}).finally(function () {
        _this6.loading.close();
      });
    },
    handleSave: function handleSave() {
      var _this7 = this;
      this.$refs['form'].validate(function (valid) {
        if (valid) {
          _this7.addHistoryInfo();
          _this7.form.forespeakBlNo = _this7.forespeakBlNo;
          _this7.loading = (0, _utils.load)();
          (0, _blExchangeAppointment.saveForespeak)(_this7.form).then(function (res) {
            if (res.success) {
              _this7.$message({
                message: _this7.$t('blExchangeAppointment.reservationSuccessful'),
                type: 'success'
              });
              _this7.closed();
            } else {
              _this7.$message.error(_this7.$t('blExchangeAppointment.reservationFailure'));
            }
          }).finally(function () {
            _this7.loading.close();
          });
        }
      });
    },
    opened: function () {
      var _opened = (0, _asyncToGenerator2.default)( /*#__PURE__*/(0, _regeneratorRuntime2.default)().mark(function _callee() {
        var _this8 = this;
        var fileId, portMediaCode;
        return (0, _regeneratorRuntime2.default)().wrap(function _callee$(_context) {
          while (1) switch (_context.prev = _context.next) {
            case 0:
              if (!this.edoCreditId) {
                _context.next = 10;
                break;
              }
              this.loading = (0, _utils.load)();
              _context.next = 4;
              return (0, _blExchangeAppointment.getForespeakAction)(this.edoCreditId, this.portCode).then(function (res) {
                if (res.success) {
                  _this8.form = res.data;
                }
              }).catch(function (error) {}).finally(function () {
                _this8.loading.close();
              });
            case 4:
              fileId = this.form.attachment;
              if (fileId) {
                (0, _booking.getFileInfo)(fileId).then(function (res) {
                  if (res.success && res.data) {
                    _this8.fileList = [{
                      name: res.data.fileName,
                      url: res.data.fileUrl,
                      fileId: res.data.fileId
                    }];
                  }
                });
              }
              portMediaCode = this.form.portMediaCode;
              if (portMediaCode) {
                (0, _booking.getFileInfo)(portMediaCode).then(function (res) {
                  if (res.success && res.data) {
                    _this8.portMediaCodeList = [{
                      name: res.data.fileName,
                      url: res.data.fileUrl,
                      fileId: res.data.fileId
                    }];
                  }
                });
              }
              _context.next = 12;
              break;
            case 10:
              this.$set(this.form, 'paymentStatus', this.paymentStatus);
              this.$set(this.form, 'forespeakStatus', this.forespeakStatus);
            case 12:
            case "end":
              return _context.stop();
          }
        }, _callee, this);
      }));
      function opened() {
        return _opened.apply(this, arguments);
      }
      return opened;
    }(),
    closed: function closed() {
      var _this9 = this;
      this.$nextTick(function () {
        _this9.$refs.form.resetFields();
      });
      this.fileList = [];
      this.portMediaCodeList = [];
      this.$emit('handleCloseReservationCommon');
    },
    uploadFile: function uploadFile(item) {
      var _this10 = this;
      if (item.file.size > 10 * 1024 * 1024) {
        this.$message.warning(this.$t('blExchangeAppointment.fileSize'));
        this.fileList = [];
        return;
      }
      var validTypes = ['application/pdf', 'image/jpeg', 'image/png', 'image/bmp', 'image/tiff'];
      if (!validTypes.includes(item.file.type)) {
        this.$message.warning(this.$t('blExchangeAppointment.fileFormat'));
        this.fileList = [];
        return;
      }
      if (item.file.name.length > 40) {
        this.$message.warning(this.$t('blExchangeAppointment.attachmentFileLength'));
        this.fileList = [];
        return;
      }
      this.loading = (0, _utils.load)();
      var formDatas = new FormData();
      formDatas.append('file', item.file);
      formDatas.append('bucket', 'commerce');
      (0, _booking.setUploadFile)(formDatas).then(function (res) {
        if (res.code) {
          _this10.form.attachment = res.fileId;
          _this10.form.attachmentName = res.fileName;
        } else {
          _this10.$message.warning(res.errorMessages[0]);
        }
      }).finally(function () {
        _this10.loading.close();
      });
    },
    uploadPortMediaCodeFile: function uploadPortMediaCodeFile(item) {
      var _this11 = this;
      if (item.file.size > 10 * 1024 * 1024) {
        this.$message.warning(this.$t('blExchangeAppointment.fileSize'));
        this.portMediaCodeList = [];
        return;
      }
      var validTypes = ['application/pdf', 'image/jpeg', 'image/png', 'image/bmp', 'image/tiff'];
      if (!validTypes.includes(item.file.type)) {
        this.$message.warning(this.$t('blExchangeAppointment.fileFormat'));
        this.portMediaCodeList = [];
        return;
      }
      if (item.file.name.length > 40) {
        this.$message.warning(this.$t('blExchangeAppointment.portMediaCodeFileLength'));
        this.portMediaCodeList = [];
        return;
      }
      this.loading = (0, _utils.load)();
      var formDatas = new FormData();
      formDatas.append('file', item.file);
      formDatas.append('bucket', 'commerce');
      (0, _booking.setUploadFile)(formDatas).then(function (res) {
        if (res.code) {
          _this11.form.portMediaCode = res.fileId;
        } else {
          _this11.$message.warning(res.errorMessages[0]);
        }
      }).finally(function () {
        _this11.loading.close();
      });
    },
    handleRemove: function handleRemove() {
      var _this12 = this;
      (0, _booking.deleteByFileId)(this.form.attachment).then(function (res) {
        if (res == 'success') {
          _this12.form.attachment = '';
          _this12.$message.success(_this12.$t('roleCertificationApplication.deleteMessage'));
        } else {
          _this12.$message.warning(res.errorMessages[0]);
        }
      });
    },
    handlePortMediaCodeRemove: function handlePortMediaCodeRemove(file, fileList) {
      var _this13 = this;
      (0, _booking.deleteByFileId)(this.form.portMediaCode).then(function (res) {
        if (res == 'success') {
          _this13.form.portMediaCode = '';
          _this13.$message.success(_this13.$t('roleCertificationApplication.deleteMessage'));
        } else {
          _this13.$message.warning(res.errorMessages[0]);
        }
      });
    }
  }
};